import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "BreadcrumbItem" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 1,
  class: "BreadcrumbLink isLast"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    (!_ctx.breadcrumb.isLast)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.url,
          class: "BreadcrumbLink",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onBreadcrumbClick && _ctx.onBreadcrumbClick(...args)), ["stop","prevent"]))
        }, _toDisplayString(_ctx.breadcrumb.name), 9 /* TEXT, PROPS */, _hoisted_2))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.breadcrumb.name), 1 /* TEXT */))
  ]))
}